import { Flex } from '../Flex';
import { Button, Card, Form, Modal } from 'antd';
import type { PropsWithChildren, ReactNode } from 'react';

export const FloatingBar = ({ children }: PropsWithChildren<unknown>) => {
  return <Card style={{ position: 'sticky', bottom: -16, zIndex: 1000 }}>{children}</Card>;
};

export const FormButtons = ({
  onBack,
  onUndo,
  onSubmit,
  onSubmitLabel = 'Save',
  onBackLabel = 'Back',
  isLoading,
  submitDanger,
  submitDisabled = false,
  touched,
  extraActions,
}: {
  onBackLabel?: string;
  onBack: () => void;
  onUndo?: () => void;
  onSubmit: () => void;
  onSubmitLabel?: string;
  isLoading: boolean;
  touched?: boolean;
  submitDanger?: boolean;
  submitDisabled?: boolean;
  extraActions?: ReactNode;
}) => {
  return (
    <Flex direction="horizontal" justifyContent="space-between">
      <Form.Item name="__touched" hidden />
      <Button disabled={isLoading} onClick={onBack}>
        {onBackLabel}
      </Button>

      <Flex direction="horizontal">
        {onUndo && (
          <Button
            onClick={() => {
              Modal.confirm({
                title: 'Undo Changes',
                content: 'Are you sure you want to undo changes?',
                onOk: () => {
                  onUndo();
                },
              });
            }}
            disabled={touched === false || isLoading}
          >
            Undo Changes
          </Button>
        )}
        {extraActions}
        <Button
          danger={submitDanger}
          onClick={onSubmit}
          loading={isLoading}
          disabled={touched === false || isLoading || submitDisabled}
          type="primary"
        >
          {onSubmitLabel}
        </Button>
      </Flex>
    </Flex>
  );
};
